module.exports = __webpack_public_path__ + "img/ic-arrow-right-white.9ec1f479.svg";